import React, {ReactNode, useState} from 'react';
import {comparisonIsValid, defaultFilters, intervals} from "services/insight";
import {InsightFilters, InsightInterval} from "types/OperatorInsights";
import {DateTime} from "luxon";
import IntervalSelect from "./IntervalSelect";
import DateInput from "./DateInput";

type Props = {
    filters?: InsightFilters
    onChange?: (filters: InsightFilters) => any
    children?: ReactNode
}

function InsightControls(props: Props) {
    const [filters, setFilters] = useState<InsightFilters>(props.filters ?? defaultFilters);

    // Helpers ----
    const selectSince = (since: DateTime) => {
        const newFilters = {...filters, since}

        setFilters(newFilters)
        props.onChange?.(newFilters)
    }

    const selectUntil = (until: DateTime) => {
        const newFilters = {...filters, until: until.endOf('day')}

        setFilters(newFilters)
        props.onChange?.(newFilters)
    }

    const selectInterval = (interval: InsightInterval | string) => {
        const newFilters = {...filters, interval: interval as InsightInterval}

        if (!comparisonIsValid(interval, filters.compare)) {
            newFilters.compare = interval as InsightInterval
        }

        setFilters(newFilters)
        props.onChange?.(newFilters)
    }

    const selectComparison = (interval: InsightInterval | string) => {
        const newFilters = {...filters, compare: interval as InsightInterval}
        setFilters(newFilters)
        props.onChange?.(newFilters)
    }

    return (
        <div className="space-y-2 lg:flex lg:space-x-6 lg:space-y-0">
            {/* Input Since */}
            <DateInput
                id="input-since"
                name="since"
                label="Since"
                value={filters.since}
                onChange={selectSince}
            />

            {/* Input Until */}
            <DateInput
                id="input-until"
                name="until"
                label="Until"
                value={filters.until}
                onChange={selectUntil}
            />

            {/* Select Interval */}
            <IntervalSelect
                id="select-interval"
                name="interval"
                label="Group by"
                value={filters.interval}
                onChange={selectInterval}
            />

            {/* Select Comparison */}
            <IntervalSelect
                id="select-comparison"
                name="comparison"
                label="Compare previous"
                value={filters.compare}
                onChange={selectComparison}
                disabledIntervals={intervals.filter(interval => !comparisonIsValid(filters.interval, interval))}
            />

            {props.children}
        </div>
    );
}

export default InsightControls;